
import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { FaToggleOn, FaToggleOff, FaExclamationTriangle } from 'react-icons/fa';

const ConfirmToggleModal = ({ isOpen, status, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  const isDisabling = status === 'approved';

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center p-4 z-50">
      <div className="bg-white w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden flex flex-col">

        {/* Top accent bar */}
        {isDisabling
          ? <div className="bg-red-500 h-1.5 w-full" />
          : <div className="bg-emerald-500 h-1.5 w-full" />
        }

        {/* Content */}
        <div className="px-6 pt-5 pb-6 space-y-4">

          {/* Close */}
          <div className="flex justify-end">
            <button
              onClick={onCancel}
              className="text-slate-400 hover:text-slate-600 transition text-xl"
              aria-label="Close"
            >
              <IoCloseOutline />
            </button>
          </div>

          {/* Icon + Text */}
          <div className="flex flex-col items-center text-center space-y-3">
            <div className={`w-16 h-16 rounded-full flex items-center justify-center ${isDisabling ? 'bg-red-100 text-red-500' : 'bg-emerald-100 text-emerald-500'}`}>
              {isDisabling ? <FaToggleOff size={32} /> : <FaToggleOn size={32} />}
            </div>

            <div>
              <h2 className="text-lg font-bold text-slate-800">
                {isDisabling ? 'Disable This Item?' : 'Enable This Item?'}
              </h2>
              <p className="text-sm text-slate-500 mt-1 leading-relaxed">
                {isDisabling
                  ? 'Are you sure you want to disable this? It will no longer be visible to users.'
                  : 'Are you sure you want to enable this? It will become visible to users.'}
              </p>
            </div>

            {/* Warning note */}
            <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5 text-left w-full">
              <FaExclamationTriangle className="text-amber-400 shrink-0 mt-0.5" size={13} />
              <p className="text-xs text-amber-700">
                This action can be reversed at any time from the dashboard.
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-3 pt-1">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2.5 rounded-xl border border-slate-200 text-slate-600 text-sm font-semibold hover:bg-slate-50 transition"
            >
              Cancel
            </button>

            {isDisabling ? (
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-2.5 rounded-xl bg-red-500 hover:bg-red-600 text-white text-sm font-semibold shadow transition"
              >
                Yes, Disable
              </button>
            ) : (
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-2.5 rounded-xl bg-green-500 hover:bg-green-600 text-white text-sm font-semibold shadow transition"
              >
                Yes, Enable
              </button>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ConfirmToggleModal;